import * as React from 'react';
import i18n from 'i18next';
import {
    headerTunables,
    opacityTunables,
    zoomTunables,
} from 'components/Sidebar/RenderTunables/SharedTunables';
import { TunablesCollapse } from 'components/Sidebar/RenderTunables/RenderTunables';
import LabelGroup from '../../components/_UI/Forms/LabelGroup/LabelGroup';
import { Widget } from '@sprinklr/stories/widget/Widget';
const ActionInput = require('../../components/_UI/Forms/Actions/ActionInput').default;

const CustomContentIframeTunables = (widget: Widget): TunablesCollapse[] => [
    {
        props: {
            label: i18n.t('Iframe'),
            startOpen: true,
        },
        children: [...headerTunables(widget, { header: true }), opacityTunables(widget)],
    },
    {
        props: {
            label: i18n.t('Content'),
            startOpen: true,
        },
        children: [
            <LabelGroup label={i18n.t('Url')} key='widget.options.contentIframeUrl'>
                <ActionInput option={widget.options} value='contentIframeUrl' />
            </LabelGroup>,
        ],
    },
    zoomTunables(widget, { zoom: true, clip: true }),
];

export default CustomContentIframeTunables;
